/*========================================================================
* $Id: voting.js -1M 2016-03-11 18:13:13Z (local) $
*
* Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
*
* Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
* Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
* Urheber festgelegten Stelle in der Funktion des Computerprogramms
* angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
* Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
* Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
* =========================================================================*/

define([
    "client/templates",
    "api/v2/api",
    "client/resourceinfo",
    "client/application",
    "api/v2/search",
    "client/template",
    "component!base",
    "i18n/i18n",
    "jquery",
    "underscore",
    "model/persisted_models"
   ], function(
     Templates,
     API,
     ResourceInfo,
     Application,
     Search,
     Template,
     Base,
     i18n,
     $,
     _,
     PersistedModels
   ) {

  /*
   Example: 
            <div style="display:none" data-template="resultfeedback" data-collection="InsightNews" data-property="isContract">                           
                <button class="action" data-resultfeedback-properties='{"value":true}'>Is Contract</button>
                <button class="action" data-resultfeedback-properties='{"value":false}'>No Contract</button>
            </div>
  */
     
  var ResultfeedbackTemplate = Template.extend({});
  
  ResultfeedbackTemplate.View = Base.extend({

    initialize: function () {
      Base.prototype.initialize.apply(this, arguments);

      var that = this;
      var actions = {};
      var collection = this.$el.attr("data-collection");
      var property = this.$el.attr("data-property");
      var feedbackCollectionModels;


      // load persisted collection
      this.options.application.models.feedbackCollection = new PersistedModels.PreviewFeedbackCollection(null, {
        channels: this.options.application.models.defaultChannels,
        appid: this.options.application.appid,
        path: ["itemdata", collection]
      });
      this.options.application.models.feedbackCollection.fetch({
        success: function(response) {
          feedbackCollectionModels = response.models;
        },
        error: function(response) { console.log(response); },
      });

      // parse actions (=buttons)
      _.each(this.$el.children("button"),function(button) {
        var actionName = button.textContent.replace(' ','_');     
        var actionValueProperties = JSON.parse($(button).attr("data-resultfeedback-properties"));
        actions[actionName] = { props: actionValueProperties, text: button.textContent }

        that.options.application[actionName] = function(e) {

          // change the object directly
          var model = e.model.get();
          if(model[property] && model[property].data) {
            model[property] = { data: [_.extend({created: ""+(new Date()).getTime(), state:"updated"},actionValueProperties)], id: property, name: property }
          } else {
            model[property] = { data: [_.extend({created: ""+(new Date()).getTime(), state:"initial"},actionValueProperties)], id: property, name: property }
          }
          e.model.output.load(model);          

          // make update or create new entry in persisted resources collection
          this.models.feedbackCollection = this.models.feedbackCollection || new PersistedModels.PreviewFeedbackCollection(null, {
              channels: this.models.defaultChannels,
              appid: this.appid,
              path: ["itemdata", collection]
          });

          var updated = false;
          
          _.each(feedbackCollectionModels,function(model) {
            var key = _.filter(model.attributes.property,function(f) { if(f.key==="key") return true; })[0].value;
            if(e.model.get("mes:key") === key) {              
              model.set("data",{
                pages: [{
                  annotations: [{
                    properties: [_.extend({created: ""+(new Date()).getTime(), state:"updated"},actionValueProperties)]
                  }]
                }]
              });
              model.save();
              updated = true;
            }            
          });  
          
          if(updated) return;

          var entry = new PersistedModels.PreviewFeedbackModel({
            path: ["itemdata", collection],
            data: {
              pages: [{
                annotations: [{
                  properties: [_.extend({created: ""+(new Date()).getTime(), state:"initial"},actionValueProperties)]
                }]
              }]
            },
            property: [
                {key: "category_instance", value: e.model.get("categoryinstance")},
                {key: "category", value: e.model.get("category")},
                {key: "key", value: e.model.get("mes:key")},
                {key: "group", value: property},
                {key: "data_type", value: "mindbreeze.api.v2.TextAnnotations"}
            ]
          });

          this.models.feedbackCollection.add(entry);
        }
      });

      API.search.on("compute", function(model, input) { });

      API.search.on("loadoutput", _.bind(function(model, atts, options) {
        if ( (atts && atts.resultset && atts.resultset.results) || (atts && atts.results) ) {
          _.each( (atts.resultset && atts.resultset.results) || atts.results, _.bind(function(result) {            
            
            // add property if existing for result            
            _.each(feedbackCollectionModels,function(model) {
              var key = _.filter(model.attributes.property,function(f) { return f.key==="key" })[0].value;
              if(result.properties["mes:key"].data[0].value === key) {          
                var data = (model.attributes.data && model.attributes.data.pages) ? model.attributes.data.pages[0].annotations[0].properties[0] : JSON.parse(model.attributes.data).pages[0].annotations[0].properties[0];
                var property = _.filter(model.attributes.property,function(f) { return f.key==="group" })[0].value; 
                result.properties[property] = { data: [data], id: property, name: property };                  
              }
            });          

            // add actions anchor elements
            _.each(_.keys(actions),function(actionName) {

              result.properties.actions && result.properties.actions.data && result.properties.actions.data.push({
                "html": "<a tabindex=\"0\" role=\"button\" data-action-name='"+actionName+"'>"+actions[actionName].text+"</a>",
                "value": {
                  "action": {
                    actionName: {}
                  }
                }
              });
              
              result.properties.actions && result.properties.actions.properties && result.properties.actions.properties.push(
                {
                  "id": actionName,
                  "name": actionName,
                  "data": [
                    {
                      "html": "<a tabindex=\"0\" role=\"button\" data-action-name='"+actionName+"'>"+actions[actionName].text+"</a>",
                      "value": {
                        "action": {
                          actionName: {}
                        }
                      }
                    }
                  ]
                });

            });            
            
          }, this));
        }}, that));

    }

  });

  return ResultfeedbackTemplate;
});
